import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'semantic-ui-react'

export default function PasswordInput({ value, onChange }) {
  function handleChange(e) {
    onChange(e.target.value)
  }
  return (
    <Form.Field>
      <label>Password</label>
      <input
        onChange={handleChange}
        value={value}
        type="password"
        name="password"
        autoComplete="current-password"
        required
      />
    </Form.Field>
  )
}

PasswordInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Login/PasswordInput/index.js